// src/pages/churches/churchConstants.js
export const REGION_OPTIONS = [
  { label: "United States (N. Virginia)\nus-east-1", value: "us-east-1" },
  { label: "Asia Pacific (Mumbai)\nap-south-1", value: "ap-south-1" },
  { label: "Europe (London)\neu-west-2", value: "eu-west-2" },
  { label: "Custom", value: "__CUSTOM__" }
];
